import LZString from 'lz-string';
import _ from 'lodash';

const STORAGE_TYPE = 'sessionStorage';

const storage = window[STORAGE_TYPE];

const KEY = {
    MODEL: 'MODEL',
    REFRESH_FLAG: 'REFRESH_FLAG',
    IS_RELOADING: 'IS_RELOADING',
    IS_RETRIEVAL: 'IS_RETRIEVAL',
    SKIP_TO_STEP: 'SKIP_TO_STEP',
    LAST_URL: 'LAST_URL',
    PAYMENT_RETRIEVAL: 'PAYMENT_RETRIEVAL',
    IS_AUTHORIZED: 'IS_AUTHORIZED',
    ACTIVE_TESTS: 'ACTIVE_TESTS',
    INVALID_SUB_QUESTIONS: 'INVALID_SUB_QUESTIONS',
    IS_TAILORMADE: 'IS_TAILORMADE',
    LAST_REQUEST_TIME: 'LAST_REQUEST_TIME',
    TIMEOUT: 'TIMEOUT',
    ORIGINAL_PAGE: 'ORIGINAL_PAGE',
    APR: 'APR',
    INTEREST_CHARGE: 'INTEREST_CHARGE',
    ACCESSIBILITY_NAVIGATION: 'ACCESSIBILITY_NAVIGATION',
    REVIEW_ID: 'REVIEW_ID',
    REVIEWING_DATA: 'REVIEWING_DATA',
    HAD_ADD_DRIVERS_PRE_REV: 'HAD_ADD_DRIVERS_PRE_REV',
    SELECTED_PAYMENT_ID: 'SELECTED_PAYMENT_ID',
    VEHICLE_PAGE_COMPLETE: 'VEHICLE_PAGE_COMPLETE',
    YOUR_VEHICLE_PAGE_COMPLETE: 'YOUR_VEHICLE_PAGE_COMPLETE',
    POLICYHOLDER_PAGE_COMPLETE: 'POLICYHOLDER_PAGE_COMPLETE',
    IS_CREDITCARD_CHANGED: 'IS_CREDITCARD_CHANGED',
    PREVENT_SKIP_TO_QUOTE_IN_RETRIEVAL: 'PREVENT_SKIP_TO_QUOTE_IN_RETRIEVAL',
    TOTAL_COST_ANNUAL: 'TOTAL_COST_ANNUAL',
    TOTAL_COST: 'TOTAL_COST',
    CHARGE_FOR_CREDIT: 'CHARGE_FOR_CREDIT',
    FIRST_INSTALMENT_DUE_DATE: 'FIRST_INSTALMENT_DUE_DATE',
    NUMBER_OF_INSTALMENTS: 'NUMBER_OF_INSTALMENTS',
    ADDON_STATE_INIT: 'ADDON_STATE_INIT',
    ADDON_STATE: 'ADDON_STATE',
    AGG_PRICE_CHANGE: 'AGG_PRICE_CHANGE',
    AGG_QUOTE_STATE: 'AGG_QUOTE_STATE',
    ADDITIONAL_DRIVER_PAGE_VISITED: 'ADDITIONAL_DRIVER_PAGE_VISITED',
    GDPR_RECONSENT: 'GDPR_RECONSENT',
    GDPR_COMMSPREF: 'GDPR_COMMSPREF',
    GDPR_CPCCALLED: 'GDPR_CPCCALLED',
    GDPR_DATA: 'GDPR_DATA',
    SUBMIT_GDPR_DATA: 'SUBMIT_GDPR_DATA',
    IS_RESOL: 'IS_RESOL',
    TRANSACTION_UID: 'TRANSACTION_UID',
    CLICK_THROUGH_ID: 'CLICK_THROUGH_ID',
    HAS_LEGAL_SELECTED: 'HAS_LEGAL_SELECTED',
    HAS_KEY_SELECTED: 'HAS_KEY_SELECTED',
    SPM_DOWNGRADE_MODAL_SHOWN: 'SPM_DOWNGRADE_MODAL_SHOWN',
    IS_RETRIEVAL_JOURNEY: 'IS_RETRIEVAL_JOURNEY',
    GDPR_AGGS_COMPLETED: 'GDPR_AGGS_COMPLETED',
    AGGS_TRACKING_PARAMS: 'AGGS_TRACKING_PARAMS',
    PRODUCT: 'PRODUCT',
    QQ_BASE_ID: 'QQ_BASE_ID',
    IS_QQ_HOME: 'IS_QQ_HOME',
    IS_QQ_MOTOR: 'IS_QQ_MOTOR',
    PREVIOUS_INSURER_CHANGED: 'PREVIOUS_INSURER_CHANGED',
    FORCE_CEP_REFRESH_TO_HOME_PAGE: 'FORCE_CEP_REFRESH_TO_HOME_PAGE',
    PAYMENT_IFRAME_CAN_BE_LOADED: 'PAYMENT_IFRAME_CAN_BE_LOADED',
    ADDON_ORIGINALLY_SELECTED: 'ADDON_ORIGINALLY_SELECTED',
    SHOW_YOUR_COVER_PAGE: 'SHOW_YOUR_COVER_PAGE',
    SPH_YOUR_PROPERTY_PAGE_VISITED: 'SPH_YOUR_PROPERTY_PAGE_VISITED',
    CEP_RENEWAL_ADDONS_PAGE_AVAILABLE: 'CEP_RENEWAL_ADDONS_PAGE_AVAILABLE',
    ACCOUNT_DDA_FORMAT: 'ACCOUNT_DDA_FORMAT',
    SCID_VALUE: 'SCID_VALUE',
    CPC_REQUEST_DATA: 'CPC_REQUEST_DATA',
    CPC_REF_DATA: 'CPC_REF_DATA',
    CPC_RESPONSE_DATA: 'CPC_RESPONSE_DATA',
    ASK_SAGA_CONSENT: 'ASK_SAGA_CONSENT',
    CPC_SAVE_CONSENT: 'CPC_SAVE_CONSENT',
    DD_APR_CAP: 'DD_APR_CAP',
    MAX_START_DATE: 'MAX_START_DATE',
    SPT_HAS_ONLY_EUROPEAN_COUNTRIES: 'SPT_HAS_ONLY_EUROPEAN_COUNTRIES',
    SPT_HAS_ONLY_UK_TRIP: 'SPT_HAS_ONLY_UK_TRIP',
    SPT_ADDED_NEW_TRAVELLER: 'SPT_ADDED_NEW_TRAVELLER',
    SPT_SEEN_MEDICAL_SCREENING: 'SPT_SEEN_MEDICAL_SCREENING',
    SPT_WAITING_LIST_MODAL_SHOWN: 'SPT_WAITING_LIST_MODAL_SHOWN',
    SPT_VERISK_TRAVELLER_ID: 'SPT_VERISK_TRAVELLER_ID',
    SPT_REDIRECT_FROM_VERISK: 'SPT_REDIRECT_FROM_VERISK',
    HEALTH_SID: 'HEALTH_SID',
    LAST_PAGE_NAME: 'LAST_PAGE_NAME',
    SPT_MEDICAL_PAGE_VISITED: 'SPT_MEDICAL_PAGE_VISITED',
    SPT_WINTER_SPORTS_EXCLUDED_TRAVELLERS: 'SPT_WINTER_SPORTS_EXCLUDED_TRAVELLERS',
    SPT_RETRIEVAL_QUOTE: 'SPT_RETRIEVAL_QUOTE',
    SPT_WAS_COVER_LEVEL_SELECTED: 'SPT_WAS_COVER_LEVEL_SELECTED',
    SPT_QUOTED_PRODUCT_TYPE: 'SPT_QUOTED_PRODUCT_TYPE',
    SPT_ANNUAL_DECLINE: 'SPT_ANNUAL_DECLINE',
    SPT_SHOW_SINGLE_TRIP_EXPIRED_MESSAGE: 'SPT_SHOW_SINGLE_TRIP_EXPIRED_MESSAGE',
    SPT_MYSAGA_AMEND: 'SPT_MYSAGA_AMEND',
    SPT_VERISK_V3_USERNAME: 'SPT_VERISK_V3_USERNAME',
    SPT_VERISK_V3_ROOTURL: 'SPT_VERISK_V3_ROOTURL',
    SPT_VERISK_V3_RESCREENING: 'SPT_VERISK_V3_RESCREENING'
};

/*
 * @see https://developer.mozilla.org/en-US/docs/Web/API/Web_Storage_API/Using_the_Web_Storage_API
 */
function storageAvailable() {
    try {
        if (!storage) {
            return false;
        }
        const x = '__storage_test__';
        storage.setItem(x, x);
        storage.removeItem(x);
        return true;
    } catch (e) {
        return e instanceof DOMException && (
            // everything except Firefox
            e.code === 22
            // Firefox
            || e.code === 1014
            // test name field too, because code might not be present
            // everything except Firefox
            || e.name === 'QuotaExceededError'
            // Firefox
            || e.name === 'NS_ERROR_DOM_QUOTA_REACHED')
            // acknowledge QuotaExceededError only if there's something already stored
            && (storage !== undefined && storage.length !== 0);
    }
}

/*
 * Checks if the storage is available
 */
const isStorageAvailable = storageAvailable();

/*
 * Validates the key. If the key is not supported or the storage is not available,
 * the is not added to the storage.
 */
function isKeyAllowed(key) {
    return isStorageAvailable && key && Object.prototype.hasOwnProperty.call(KEY, key);
}

function setArray(items, key) {
    const arrayCopy = [...items];
    storage.setItem(key, LZString.compressToUTF16(JSON.stringify(arrayCopy)));
}

function getArray(key) {
    if (!isStorageAvailable) {
        return undefined;
    }
    const arrayJSON = storage.getItem(key);
    if (!arrayJSON) {
        return [];
    }

    return JSON.parse(LZString.decompressFromUTF16(arrayJSON));
}

/*
 * Retrieves the model from the storage.
 * The object is kept as compressed, JSON representation.
 * The function decompressed the JSON string and parses it.
 */
function getModel() {
    if (!isStorageAvailable) {
        return null;
    }
    const modelJSON = storage.getItem(KEY.MODEL);
    if (!modelJSON) {
        return null;
    }
    const model = JSON.parse(LZString.decompressFromUTF16(modelJSON));
    return model;
}

/*
 * Checks if the keep is allowed and retrieves the object to the storage.
 */
function getItem(key) {
    if (!isKeyAllowed(key)) {
        return undefined;
    }
    if (key === KEY.MODEL) {
        return getModel();
    }
    if (key === KEY.ACTIVE_TESTS || key === KEY.INVALID_SUB_QUESTIONS) {
        return getArray(key);
    }
    return storage.getItem(key);
}

/*
 * Adds the model to the storage.
 * The object is kept as compressed, JSON representation.
 * The function removes quote and bind data from the object if they exist.
 * If quote data are present, it means that there is enough data to restore the object from DB.
 * Only Submission and Renewal models are allowed.
 */
function setModel(model) {
    if (!model) {
        return;
    }
    const modelCopy = _.cloneDeep(model);
    // used to restore tempIDs counter after reload
    // modelCopy.nextGenId = SgIdGenerator.getNextIdNoAssignment();
    modelCopy.quoteData = undefined;
    modelCopy.bindData = undefined;
    storage.setItem(KEY.MODEL, LZString.compressToUTF16(JSON.stringify(modelCopy)));
}

/*
 * Checks if the keep is allowed and adds the object to the storage.
 */
function setItem(key, item) {
    if (!isKeyAllowed(key)) {
        return;
    }
    if (key === KEY.MODEL) {
        setModel(item);
    } else if (key === KEY.ACTIVE_TESTS || key === KEY.INVALID_SUB_QUESTIONS) {
        setArray(item, key);
    } else {
        storage.setItem(key, item);
    }
}

/*
 * Checks if the keep is allowed and removes the object to the storage.
 */
function removeItem(key) {
    if (!isKeyAllowed(key)) {
        return;
    }
    storage.removeItem(key);
}

function clearSessionStorage() {
    storage.clear();
}

export default {
    KEY,
    getItem,
    setItem,
    removeItem,
    clearSessionStorage
};
